import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, UserPermissions } from '../types/items';
import { transformList } from './transformer';

class UserPermissionService {
  private route = apis.userPermissions;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<UserPermissions>>(this.route.default, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<UserPermissions>(`${this.route.default}/${id}`);

  template = () => this.api.get<UserPermissions>(`${this.route.default}/new`);

  save = (id: ItemId, { ref, permissions, ...project }: UserPermissions) => this.api.put(`${this.route.default}/${id}`, project);

  create = ({
              id, ref, permissions, ...project
            }: UserPermissions) => this.api.post<UserPermissions>(this.route.default, project);

  delete = (id: ItemId) => this.api.delete(`${this.route.default}/${id}`);

  invite = ({id, cc_sender} : UserPermissions) => this.api.put(`${this.route.default}/${id}/invite`, {cc_sender});

  listByUser = (userId: number) => {
    const params = {
      sort_key: 'ref.organization.common_name',
      sort_dir: 'asc',
      filter: {
        user_id: userId,
      },
      page_size: 100,
    };
    return this.api.get<List<UserPermissions>>(this.route.default, params).then(transformList);
  }
}

export default new UserPermissionService(apiService);
